var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":'#' + _vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }